import moment from 'moment-business-days';
import 'moment/locale/fr';

//moment.locale('fr');
moment.updateLocale('fr', {
    workingWeekdays: [1, 2, 3, 4, 5]
 });

export default moment;